(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Aggiorna il carrello quando cambia una quantità (fallback: bottone
  // "Aggiorna carrello" per chi non ha JS). Delegation sul documento così
  // sopravvive ai reload di sezione del theme editor.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-gi-cart-qty]')) return;
    var form = input.closest('form');
    if (form) form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeDialog(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-gi-menu-open]');
      if (opener) {
        var header = opener.closest('.gi-header');
        var dialog = header ? header.querySelector('[data-gi-menu-dialog]') : null;
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }

      var closer = event.target.closest('[data-gi-menu-close]');
      if (closer) {
        closeDialog(closer.closest('[data-gi-menu-dialog]'));
        return;
      }

      var dialogEl = event.target.closest('[data-gi-menu-dialog]');
      if (!dialogEl) return;

      if (event.target === dialogEl) {
        // Click sul backdrop (o sul padding del dialog): chiudi.
        closeDialog(dialogEl);
        return;
      }

      if (event.target.closest('a')) {
        closeDialog(dialogEl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  // Pagina indirizzi: popola le province dal data-provinces delle option
  // di all_country_option_tags, preseleziona paese/provincia correnti
  // (data-default), chiude i pannelli <details> con i bottoni "Annulla" e
  // chiede conferma prima di eliminare un indirizzo. Tutto a delegation
  // sul documento, così sopravvive ai reload di sezione del theme editor.
  (function () {
    'use strict';

    function updateProvinces(countrySelect) {
      var scope = countrySelect.closest('[data-gi-addr-form]');
      if (!scope) return;
      var wrap = scope.querySelector('[data-gi-addr-province-wrap]');
      var provinceSelect = scope.querySelector('[data-gi-addr-province]');
      if (!wrap || !provinceSelect) return;

      var option = countrySelect.options[countrySelect.selectedIndex];
      var raw = option ? option.getAttribute('data-provinces') : null;
      var provinces = [];
      if (raw) {
        try {
          provinces = JSON.parse(raw);
        } catch (err) {
          provinces = [];
        }
      }

      provinceSelect.innerHTML = '';

      if (!provinces || !provinces.length) {
        wrap.hidden = true;
        return;
      }

      var current = provinceSelect.getAttribute('data-default') || '';
      provinces.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        if (pair[0] === current || pair[1] === current) opt.selected = true;
        provinceSelect.appendChild(opt);
      });
      wrap.hidden = false;
    }

    function initCountrySelect(countrySelect) {
      if (countrySelect.dataset.giAddrInit === 'true') return;
      countrySelect.dataset.giAddrInit = 'true';

      var preset = countrySelect.getAttribute('data-default');
      if (preset) {
        for (var i = 0; i < countrySelect.options.length; i++) {
          var option = countrySelect.options[i];
          if (option.value === preset || option.textContent.trim() === preset) {
            countrySelect.selectedIndex = i;
            break;
          }
        }
      }

      updateProvinces(countrySelect);
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-gi-addr-country]').forEach(initCountrySelect);
    }

    document.addEventListener('change', function (event) {
      var el = event.target;
      if (el.matches && el.matches('[data-gi-addr-country]')) updateProvinces(el);
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var btn = event.target.closest('[data-gi-addr-close]');
      if (!btn) return;
      var details = btn.closest('details');
      if (details) details.removeAttribute('open');
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('[data-gi-addr-delete]')) return;
      var message = form.getAttribute('data-confirm');
      if (message && !window.confirm(message)) event.preventDefault();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  // Toggle accesso/recupero senza cambiare l'URL: i link [data-gi-auth-show]
  // mostrano il pannello richiesto e nascondono l'altro. Senza JS resta il
  // fallback CSS con :target (ancora #recover). Delegation sul documento
  // così sopravvive ai reload di sezione del theme editor.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-gi-auth-show]') : null;
    if (!trigger) return;
    var root = trigger.closest('[data-gi-auth]');
    if (!root) return;
    event.preventDefault();

    var name = trigger.getAttribute('data-gi-auth-show');
    var panels = root.querySelectorAll('[data-gi-auth-panel]');
    for (var i = 0; i < panels.length; i += 1) {
      var panel = panels[i];
      var isTarget = panel.getAttribute('data-gi-auth-panel') === name;
      panel.classList.toggle('is-open', isTarget);
      panel.classList.toggle('is-hidden', !isTarget);
      if (isTarget) {
        var input = panel.querySelector('input');
        if (input) input.focus();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function finishFor(value) {
      var v = (value || '').toLowerCase();
      if (v.indexOf('rosa') > -1) return { tone: 'gi-tone-1', finish: 'rose' };
      if (v.indexOf('argento') > -1) return { tone: 'gi-tone-6', finish: 'silver' };
      if (v.indexOf('oro') > -1) return { tone: 'gi-tone-3', finish: 'gold' };
      return { tone: 'gi-tone-3', finish: 'gold' };
    }

    function initProduct(root) {
      if (root.dataset.giInit === 'true') return;
      root.dataset.giInit = 'true';

      var variants = [];
      var dataEl = root.querySelector('[data-gi-variants]');
      if (dataEl) {
        try {
          variants = JSON.parse(dataEl.textContent) || [];
        } catch (error) {
          variants = [];
        }
      }

      var idInput = root.querySelector('[data-gi-id]');
      var priceEl = root.querySelector('[data-gi-price]');
      var compareEl = root.querySelector('[data-gi-compare]');
      var submitBtn = root.querySelector('[data-gi-submit]');
      var form = root.querySelector('.gi-product__form');
      var paymentEl = form ? form.querySelector('.shopify-payment-button') : null;
      var previewBg = root.querySelector('[data-gi-preview-bg]');
      var pendant = root.querySelector('[data-gi-pendant]');
      var currency = root.dataset.giCurrency || 'EUR';
      var soldOutLabel = root.dataset.giSoldOutLabel || '';
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-gi-option-group]'));

      function selectedOptions() {
        var values = [];
        groups.forEach(function (group) {
          var index = parseInt(group.dataset.giOptionGroup, 10) - 1;
          var checked = group.querySelector('input:checked');
          values[index] = checked ? checked.value : null;
        });
        return values;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i += 1) {
          var variant = variants[i];
          var matches = true;
          for (var j = 0; j < values.length; j += 1) {
            if (values[j] && variant['option' + (j + 1)] !== values[j]) {
              matches = false;
              break;
            }
          }
          if (matches) return variant;
        }
        return null;
      }

      function applyVariant(variant) {
        var available = false;
        if (variant && variant.available) available = true;
        if (idInput) {
          if (variant) {
            idInput.value = variant.id;
          } else {
            idInput.value = '';
          }
        }
        if (variant && priceEl) priceEl.textContent = formatMoney(variant.price, currency);
        if (variant && compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price, currency);
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.textContent = '';
            compareEl.setAttribute('hidden', 'hidden');
          }
        }
        if (submitBtn) {
          var addLabel = submitBtn.dataset.giAddLabel || submitBtn.textContent;
          submitBtn.disabled = !available;
          submitBtn.textContent = available ? addLabel : soldOutLabel;
        }
        if (paymentEl) paymentEl.style.display = available ? '' : 'none';
        if (form) form.toggleAttribute('data-gi-unavailable', !available);
      }

      function applyFinish(value) {
        var map = finishFor(value);
        if (previewBg) previewBg.className = 'gi-ph ' + map.tone + ' gi-product__preview-bg';
        if (pendant) pendant.className = 'gi-product__pendant gi-product__pendant--' + map.finish;
      }

      groups.forEach(function (group) {
        group.addEventListener('change', function (event) {
          group.querySelectorAll('.gi-product__chip').forEach(function (chip) {
            var input = chip.querySelector('input');
            var isChecked = false;
            if (input && input.checked) isChecked = true;
            chip.classList.toggle('is-selected', isChecked);
          });
          applyVariant(findVariant(selectedOptions()));
          if (group.hasAttribute('data-gi-finish') && event.target && event.target.value) {
            applyFinish(event.target.value);
          }
        });
      });

      var finishGroup = root.querySelector('[data-gi-finish]');
      if (finishGroup) {
        var checkedFinish = finishGroup.querySelector('input:checked');
        if (checkedFinish) applyFinish(checkedFinish.value);
      }

      var engraveInput = root.querySelector('[data-gi-engrave]');
      var engraveOut = root.querySelector('[data-gi-engrave-out]');
      if (engraveInput && engraveOut) {
        var fallback = engraveOut.dataset.giEngraveFallback || engraveOut.textContent;
        var sync = function () {
          var text = engraveInput.value.trim();
          engraveOut.textContent = text || fallback;
        };
        engraveInput.addEventListener('input', sync);
        if (engraveInput.value) sync();
      }
    }

    function initAll(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll('[data-gi-product]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
